import "datatables.net-dt/js/dataTables.dataTables.js";
import { Icon } from "@iconify/react/dist/iconify.js";
import { toast } from 'react-toastify';
import { Modal, Popover, Tabs } from 'antd';
import { useNavigate } from "react-router-dom";
import { api } from "../../utils/apiClient";
import { useSelector } from "react-redux";
import { API } from "../../config/constants";
import Pagination from "../../utils/Pagination";
import { formatDateToDMY, formatTime12Hour, formatEventType } from "../../utils/tools";
import ContentLoader from "../../utils/ContentLoader";
import { useState } from "react";
import SearchBy from "../../utils/SearchBy";
import { TableSortHeaders } from "../../utils/TableSortHeaders";
import ImagePreviewModal from "../../utils/ImagePreviewModal";

const { confirm } = Modal;

const BookMarkTable = ({
    bookMark,
    roles,
    page,
    setPage,
    totalPages,
    totalEntries,
    sort,
    order,
    setOrder,
    setSort,
    search,
    setSearch,
    fetchBookMark,
    onView,
    entriesPerPage,
    setEntriesPerPage
}) => {
    const viewPermissions = useSelector((state) => state.permission.rolePermissions) || [];
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const headerConfig = [
        //  { key: "id", label: "ID", sortable: false },
        { key: "user_name", label: "User Name", sortable: false },
        { key: "registered_at", label: "Registered At", sortable: false },
        { key: "user_email", label: "Email", sortable: false },
        { key: "folder_count", label: "Folders Count", sortable: false },
        { key: "verses_count", label: "Verses Count", sortable: false },
        { key: "action", label: "Action", sortable: false }
    ];

    console.log("bookMark table =====>", bookMark);

    if (loading) return <ContentLoader />;

    return (
        <div className="card basic-data-table text-sm overflow-x-auto">
            <div className="card-header responsive-header d-flex justify-content-end align-items-center global-header">
                <div className="d-flex align-items-center gap-3">
                    {/* Refresh Icon */}
                    <Icon
                        icon="mdi:refresh"
                        width="26"
                        height="26"
                        className="ms-2 text-lg d-none d-md-inline-flex refresh-icon "
                        onClick={fetchBookMark}
                    />

                    <div className="search-container" style={{ gap: "10px" }}>
                        <SearchBy
                            value={search}
                            onChange={(e) => {
                                setSearch(e.target.value);
                                setPage(1);
                            }}
                        />
                    </div>
                </div>
            </div>
            <div className="card-body card-body-modify">
                <div className="w-full overflow-x-auto">
                    <table className="table bordered-table mb-0 text-sm w-full min-w-max" id="dataTable">
                        <thead>
                            <tr>
                                {TableSortHeaders(headerConfig, sort, order, setSort, setOrder, setPage)}
                            </tr>
                        </thead>
                        <tbody>
                            {Array.isArray(bookMark) && bookMark.length > 0 ? (
                                bookMark.map((item) => {
                                    const folderCount = item.folders.length; // total folders
                                    const verseCount = item.folders.reduce(
                                        (acc, folder) => acc + (folder.verses ? folder.verses.length : 0),
                                        0
                                    ); // sum of all verses

                                    return (
                                        <tr key={item.user.id}>
                                            {/* User */}
                                            <td className="d-flex align-items-center gap-2">
                                                <ImagePreviewModal
                                                    src={item.user?.avatar || "/assets/images/logo-profile.png"}
                                                    fallback="/assets/images/logo-profile.png"
                                                    alt={item.user?.name}
                                                    thumbWidth={50}
                                                    thumbHeight={50}
                                                />
                                                <span>{item.user?.name}</span>
                                            </td>

                                            <td>
                                                {item.user?.created_at
                                                    ? `${formatDateToDMY(item.user?.created_at)} ${formatTime12Hour(item.user?.created_at)
                                                    }`
                                                    : "-"}
                                            </td>

                                            {/*  Email */}
                                            <td>{item.user?.email}</td>

                                            {/* Folder Count */}
                                            <td>{folderCount}</td>

                                            {/* Verses Count */}
                                            <td>{verseCount}</td>

                                            {/* Actions */}
                                            <td>
                                                <div className="d-flex align-items-center justify-content-between">

                                                    {/* Left Side - View Icon */}
                                                    {viewPermissions.includes("event.view") && (
                                                        <button
                                                            className="w-32-px h-32-px me-8 bg-primary-light text-primary-600 rounded-circle d-inline-flex align-items-center justify-content-center"
                                                            onClick={() => onView(item)}
                                                        >
                                                            <Icon icon="iconamoon:eye-light" />
                                                        </button>
                                                    )}
                                                </div>
                                            </td>


                                        </tr>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td colSpan={7} className="text-center">
                                        No Bookmark found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
                <Pagination
                    page={page}
                    setPage={setPage}
                    totalPages={totalPages}
                    totalEntries={totalEntries}
                    entriesPerPage={entriesPerPage}
                    setEntriesPerPage={setEntriesPerPage}
                />
            </div>
        </div>
    );
};

export default BookMarkTable;